import React from 'react';
import { getBrand } from '../utils/brand';

// "Powered by AyudaTecno" — la firma en la instancia de un cliente.
//
// La plataforma se le entrega con SU marca: su logo, su nombre, sus colores. Pero quién la
// hace tiene que verse, porque cada persona del colegio que la usa todos los días es alguien
// que después sabe a quién llamar. Es marca, no crédito legal: por eso va discreto y abajo,
// nunca compitiendo con el logo del cliente.
//
// No se dibuja en NUESTRA instancia (`esAyudaTecno`): ahí sería el mismo logo dos veces.
//
// `size`: 'sm' para el pie del login, 'xs' para la barra lateral, donde el espacio es poco.
export default function PoweredByAyudaTecno({ size = 'sm', style }) {
  const marca = getBrand();
  if (marca.esAyudaTecno) return null;

  const chico = size === 'xs';
  const alto = chico ? 14 : 18;

  return (
    <a
      href="https://www.ayudatecno.com.ar"
      target="_blank"
      rel="noopener noreferrer"
      title="Plataforma desarrollada y operada por AyudaTecno"
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 6,
        fontSize: chico ? 10 : 11, color: 'var(--c-text-muted)',
        textDecoration: 'none', opacity: 0.85, ...style,
      }}
    >
      <span>Powered by</span>
      {/* /logo.jpg lo sirve el propio frontend, que es el MISMO build en todas las
          instancias — así que en la de un cliente sigue siendo nuestro logo, sin depender
          de que nuestro servidor esté arriba. */}
      <img src="/logo.jpg" alt="AyudaTecno" style={{ height: alto, width: alto, borderRadius: 4, objectFit: 'cover' }} />
      <strong style={{ fontWeight: 600, color: 'var(--c-text-muted)' }}>AyudaTecno</strong>
    </a>
  );
}
